(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    function gxInitMenuDrawerHandle() {
    const handle = document.getElementById('MenuDrawerHandle');
    if (!handle) return;

    const closeDrawer = () => {
      const summary = document.querySelector('#Details-menu-drawer-container > summary');
      if (summary) summary.click();
    };

    handle.addEventListener('click', closeDrawer);
    handle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gxInitMenuDrawerHandle, { once: true });
  } else {
    gxInitMenuDrawerHandle();
  }
  } catch(e) { console.error(e); }
})();

})();
